module.exports = __webpack_public_path__ + "img/Fmsc.1dba8562.svg";